import { c as _c } from "react/compiler-runtime";
import { SphereDropdownButton } from "@components/common/dropdown/sphere-dropdown-button";
import { SphereDropdownSelector } from "@components/common/dropdown/sphere-dropdown-selector";
import { Stack } from "@mui-wrapper";
import { ALL_AREAS, CAPTURE_DATE_FILTER_OPTIONS } from "@pages/project-details/project-overview/captured-data-summary/captured-data-summary-utils";
/** @returns the options of the area filter, with the area names excluded from translation */
function getAreaOptions(areas) {
  return [{
    value: ALL_AREAS,
    label: "All areas"
  }, ...areas.map(({
    id,
    name
  }) => ({
    value: id,
    label: <var>{name}</var>
  }))];
}

/** Filters of the captured data summary: the area and how recently the photos were captured */
export function CapturedDataSummaryFilters(t0) {
  const $ = _c(11);
  const {
    areas,
    areaId,
    dateFilter,
    onAreaChange,
    onDateFilterChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: 2,
      flexWrap: "wrap"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== areaId || $[2] !== areas || $[3] !== onAreaChange) {
    t2 = areas.length > 1 && <SphereDropdownSelector items={getAreaOptions(areas)} currentValue={areaId} handleChange={onAreaChange} renderButton={_temp} />;
    $[1] = areaId;
    $[2] = areas;
    $[3] = onAreaChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== dateFilter || $[6] !== onDateFilterChange) {
    t3 = <SphereDropdownSelector items={CAPTURE_DATE_FILTER_OPTIONS} currentValue={dateFilter} handleChange={onDateFilterChange} renderButton={_temp2} />;
    $[5] = dateFilter;
    $[6] = onDateFilterChange;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <Stack direction="row" sx={t1}>{t2}{t3}</Stack>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp2(props_0) {
  return <SphereDropdownButton {...props_0} />;
}
function _temp(props) {
  return <SphereDropdownButton {...props} />;
}